/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { I18n } from '@trebox-arch/i18n';
import { type ColumnProps } from '@coze-arch/coze-design';
import { type PersonalAccessToken } from '@trebox-arch/bot-api/pat_permission_api';
export const columnNameConf: () => ColumnProps<PersonalAccessToken> = () => ({
  title: I18n.t('coze_api_list1'),
  dataIndex: 'name',
  width: 120,
  render: (name: string) => <p>{name}</p>,
});
